module.exports = __webpack_public_path__ + "img/ico08.edbcf4a1.svg";